import React from "react";
import { Button } from "primereact/button";
import { CombinedInvitationRequest } from "../viewmodel/InvitationsViewModel";

interface InvitationsListProps {
  invitations: CombinedInvitationRequest[];
  loading: boolean;
  onAccept: (actionId: string) => void;
  onDeny: (actionId: string) => void;
  onWithdraw: (uid: string) => void;
  isAdmin: boolean;
}

export const InvitationsList: React.FC<InvitationsListProps> = ({
  invitations,
  loading,
  onAccept,
  onDeny,
  onWithdraw,
  isAdmin,
}) => {
  if (loading) {
    return <div className="text-center py-4">Loading...</div>;
  }

  if (invitations.length === 0) {
    return (
      <div className="text-center py-4 text-gray-500">
        No pending requests or invitations
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {invitations.map((item) => (
        <div
          key={`${item.type}-${item.action_id}`}
          className="organization-item-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "40px 1fr auto",
            gap: "1rem",
            alignItems: "center",
            padding: "0.75rem",
            border: "1px solid #e5e7eb",
            borderRadius: "0.5rem",
          }}
        >
          {/* Avatar */}
          <div
            className="avatar"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "#f3f4f6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {item.user_data.logo_uri ? (
              <img
                src={item.user_data.logo_uri}
                alt={item.user_data.username}
                style={{
                  width: "40px",
                  height: "40px",
                  objectFit: "cover",
                }}
              />
            ) : (
              <span
                style={{
                  color: "#6b7280",
                  fontWeight: 500,
                  fontSize: "0.875rem",
                }}
              >
                {item.user_data.firstname.charAt(0)}
                {item.user_data.lastname.charAt(0)}
              </span>
            )}
          </div>

          {/* User Info */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ fontWeight: 500, color: "#111827" }}>
              {item.user_data.firstname} {item.user_data.lastname}
            </div>
            <div style={{ fontSize: "0.875rem", color: "#6b7280" }}>
              {item.user_data.email}
            </div>
          </div>

          {/* Actions */}
          {isAdmin && (
            <div
              style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}
            >
              {item.type === "request" ? (
                <>
                  <Button
                    size="small"
                    className="p-button-default"
                    onClick={() => onAccept(item.action_id)}
                  >
                    Accept request to join
                  </Button>
                  <Button
                    size="small"
                    className="p-button-outlined p-button-warning"
                    onClick={() => onDeny(item.action_id)}
                  >
                    Deny
                  </Button>
                </>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    gap: "0.25rem",
                  }}
                >
                  {/* <div style={{ fontSize: "0.75rem", color: "#6b7280" }}>
                    Invited: {item.invite_date}
                  </div> */}
                  <Button
                    size="small"
                    className="p-button-outlined p-button-secondary"
                    onClick={() => onWithdraw(item.uid)}
                  >
                    Withdraw invitation
                  </Button>
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
